"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyReportsWeeklyGeneral = void 0;
const zod_1 = require("zod");
exports.legacyReportsWeeklyGeneral = zod_1.z.object({
    reportIds: zod_1.z.array(zod_1.z.string()).optional(),
    includeDeleted: zod_1.z.boolean().default(false).optional(),
    attributes: zod_1.z
        .object({
        createdAt: zod_1.z.literal(true).optional(),
        updatedAt: zod_1.z.literal(true).optional(),
        deletedAt: zod_1.z.literal(true).optional(),
        reportId: zod_1.z.literal(true).optional(),
        name: zod_1.z.literal(true).optional(),
        notifyOwnerByEmail: zod_1.z.literal(true).optional(),
        contacts: zod_1.z
            .object({
            contactId: zod_1.z.literal(true).optional(),
            email: zod_1.z.literal(true).optional(),
            language: zod_1.z.literal(true).optional(),
            name: zod_1.z.literal(true).optional(),
            sms: zod_1.z.literal(true).optional(),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: "Must request at least one attribute of the report's contacts",
        }),
        groups: zod_1.z
            .object({
            groupId: zod_1.z.literal(true).optional(),
            name: zod_1.z.literal(true).optional(),
            contactsForGroup: zod_1.z
                .object({
                contactId: zod_1.z.literal(true).optional(),
                email: zod_1.z.literal(true).optional(),
                language: zod_1.z.literal(true).optional(),
                name: zod_1.z.literal(true).optional(),
                sms: zod_1.z.literal(true).optional(),
            })
                .optional()
                .refine((args) => !args || !!Object.keys(args || {}).length, {
                message: "Must request at least one attribute of the report's groups' contacts",
            }),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: "Must request at least one attribute of the report's groups",
        }),
        dayOfWeek: zod_1.z.literal(true).optional(),
        propertyIds: zod_1.z.literal(true).optional(),
        chill: zod_1.z.literal(true).optional(),
        evapotranspiration: zod_1.z.literal(true).optional(),
        fireBlight: zod_1.z.literal(true).optional(),
        growingDegreeDays: zod_1.z.literal(true).optional(),
        insects: zod_1.z.literal(true).optional(),
        irrigationActivity: zod_1.z.literal(true).optional(),
        pollination: zod_1.z.literal(true).optional(),
        soilMoisture: zod_1.z.literal(true).optional(),
        weather: zod_1.z.literal(true).optional(),
    })
        .optional()
        .refine((args) => !args || !!Object.keys(args || {}).length, {
        message: 'Must request at least one attribute for the report if specifying any at all',
    }),
});
//# sourceMappingURL=legacyReportsWeeklyGeneral.js.map